<template>
  <div v-if="enableWorkbuster && workbusterReady">
    <div class="container workbuster">
      <div class="content" v-if="workbusterTitle">
        <div class="aligncenter">
          <h2 v-text="workbusterTitle"></h2>
        </div>
      </div>
      <div id="workbuster_container"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["blockdata"],
  name: "block-workbuster-component",
  data() {
    return {
      workbusterReady: false,
      workbusterTitle: this.blockdata.name,
      enableWorkbuster: this.blockdata.enable_workbuster
    };
  },
  mounted: function() {
    if(this.enableWorkbuster) {
      this.workbusterReady = true;
      let workbusterScript = document.createElement('script')
      workbusterScript.setAttribute('src', 'https://primepr.workbuster.com/embed?container=workbuster_container')
      document.head.appendChild(workbusterScript);
    }
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// BlockWorkbusterComponent.vue?64ef4442